<app-public-header *ngIf="!isAuthenticated"></app-public-header>
<div class="pb-30 pt-30 school-invites" [ngClass]="{'pt-80': !isAuthenticated}">
    <div class="container mb-30">
        <app-article *ngIf="isAuthenticated" [pageName]="'JOBS'"
            (pageTeacherDataLoaded)="handlePageData($event)"></app-article>

        <ng-container *ngIf="jobsFiltersForm.value.is_camp_aus">
            <a class="user-title clr-cc-vilot c-p" (click)="applyFilters('global_search', 'regularJobs')"><i
                    class="bi bi-arrow-left"></i> Go to all jobs</a>
            <div class="camp-card   mt-20 p-3 c-p">
                <img src="assets/images/camp_aus_image.png" alt="Camp Australia Logo" width="100px" />
            </div>
            <div class="pl-40 pr-40">
                <div class="camp-wrapper">
                    <!-- Corner Images -->
                    <img src="assets/images/shape1.png" class="corner-left top-left" />
                    <img src="assets/images/shape2.png" class="corner-right top-right" />
                    <img src="assets/images/shape3.png" class="corner-bottom-left bottom-left" />
                    <img src="assets/images/shape4.png" class="corner-bottom-right bottom-right" />

                    <div class="camp-sec-card mb-20 px-35 c-p">
                        <p>At Camp Australia, children are at the heart of everything we do. With 30 years of
                            experience in OSHC, we provide the most engaging programs tailored for each child
                            with
                            dedication to prioritising their wellbeing. This is our promise of supporting
                            families
                            in achieving their dreams.</p>
                    </div>
                </div>
            </div>
        </ng-container>

        <form [formGroup]="jobsFiltersForm">
            <ng-container *ngIf="activeTab === 'all-jobs'">
                <div class="card p-3 mb-20">
                    <div class="container-search">
                        <div class="search-bar-jobs">
                            <!-- Search Input -->
                            <div class="position-relative">
                                <i class="bi bi-search input-icon"></i>
                                <input type="text" class="form-control search-input" formControlName="global_search"
                                    placeholder="Search by job title, subject, school, level, etc..."
                                    (keydown.enter)="$event.stopPropagation(); applyFilters('global_search')" />
                            </div>

                            <!-- Location Input -->
                            <div class="position-relative">
                                <i class="bi bi-geo-alt input-icon"></i>
                                <input type="text" class="form-control search-input" formControlName="address_search"
                                    placeholder="Location (suburb, postcode)"
                                    (keydown.enter)="$event.stopPropagation(); applyFilters('global_search')" />
                            </div>

                            <!-- Buttons -->
                            <button class="cc_p_btn fs-12" type="button"
                                (click)="$event.stopPropagation();applyFilters('global_search')">
                                Search
                            </button>

                            <button class="btn-outline d-flex align-items-center gap-2" type="button"
                                data-bs-toggle="offcanvas" data-bs-target="#filtersOffcanvas"
                                aria-controls="filtersOffcanvas">
                                <i class="bi bi-sliders"></i>
                                <span class="d-md-inline">Filters</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Filters Offcanvas -->
                <div class="offcanvas offcanvas-end" tabindex="-1" id="filtersOffcanvas"
                    aria-labelledby="filtersOffcanvasLabel">
                    <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="filtersOffcanvasLabel">Filters<br>
                            <p class="txt-regular">Refine your job search
                            </p>
                        </h5>
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                            aria-label="Close"></button>
                    </div>
                    <div class="offcanvas-body d-flex flex-column p-0" style="height:100%">
                        <form [formGroup]="jobsFiltersForm"
                            (ngSubmit)="$event.stopPropagation();applyFilters('global_search')"
                            class="d-flex flex-column h-100">
                            <div class="filters-panel flex-grow-1 overflow-auto px-15 pt-3">
                                <!-- Job Type -->
                                <div class="filter-section">
                                    <h6 class="mb-2 txt-regular fs-16">Job Type</h6>
                                    <p class="txt-regular fs-12">Select employment types</p>
                                    <div class="d-flex align-items-center flex-wrap">
                                        <div class="form-check mt-5 mr-15" *ngFor="let type of jobTypes">
                                            <input class="form-check-input mt-4" type="checkbox"
                                                [checked]="isArrayAndIncludes(jobsFiltersForm.value.job_type, type.value)"
                                                (change)="onJobTypeChange($event, type.value)" />
                                            <label class="form-check-label">{{ type.label }}</label>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <!-- School Type -->
                                <div class="filter-section mt-20">
                                    <h6 class="mb-2 txt-regular fs-16">School Type</h6>
                                    <p class="txt-regular fs-12">Filter by school category</p>
                                    <div class="d-flex align-items-center flex-wrap">
                                        <div class="form-check mt-5 mr-15" *ngFor="let school of schoolTypes">
                                            <input class="form-check-input mt-4" type="checkbox"
                                                [checked]="isArrayAndIncludes(jobsFiltersForm.value.school_type, school.value)"
                                                (change)="onSchoolTypeChange($event, school.value)" />
                                            <label class="form-check-label">{{ school.label }}</label>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <!-- Distance -->
                                <div class="filter-section mt-20">
                                    <h6 class="mb-2 txt-regular fs-16">Distance from Location</h6>
                                    <p class="txt-regular fs-12">Maximum commute distance</p>
                                    <select class="form-select mt-5" formControlName="job_distance">
                                        <option value="10000000">Any</option>
                                        <option value="5">5 km</option>
                                        <option value="10">10 km</option>
                                        <option value="25">25 km</option>
                                        <option value="50">50 km</option>
                                        <option value="250">250 km</option>

                                    </select>
                                </div>
                            </div>
                            <!-- Actions fixed at bottom -->
                            <div class="filter-actions p-3 border-top bg-white position-sticky bottom-0 w-100"
                                style="z-index:2;">
                                <button (click)="removeAllFiler()" type="button" class="btn-outline w-100 mb-10">
                                    Clear all
                                </button>
                                <button type="submit" class="cc_p_btn fs-12 w-100" data-bs-dismiss="offcanvas">
                                    Apply filters
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- Applied Filters Chips -->
                <div *ngIf="appliedFilterChips.length > 0" class="mb-2 d-flex align-items-center flex-wrap gap-2 mt-10">
                    <p class="text-regular-medium clr-grey-3">Active Filters:</p>
                    <ng-container *ngFor="let chip of appliedFilterChips">
                        <span class="badge active-filter fs-12 text-regular-medium d-flex align-items-center">
                            {{ chip.label }}
                            <button type="button" class="btn-close ms-2" aria-label="Remove"
                                (click)="removeFilterChip(chip)"></button>
                        </span>
                    </ng-container>
                    <a role="button" (click)="removeAllFiler()" class="text-regular-medium clr-cc-vilot">Clear
                        all</a>
                </div>
            </ng-container>

            <div class="container">
                <div class="row">
                    @if(!this.jobsFiltersForm.value.is_camp_aus) {
                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <ng-container *ngIf="isAuthenticated">
                                <button class="nav-link" [ngClass]="{ active: activeTab === 'all-jobs' }"
                                    (click)="onTabChange('all-jobs')" id="nav-all-jobs-tab" data-bs-toggle="tab"
                                    data-bs-target="#nav-all-jobs" type="button" role="tab" aria-controls="nav-all-jobs"
                                    aria-selected="true">
                                    All Jobs
                                </button>
                                <button class="nav-link" [ngClass]="{ active: activeTab === 'saved' }"
                                    (click)="onTabChange('saved')" id="nav-saved-tab" data-bs-toggle="tab"
                                    data-bs-target="#nav-saved" type="button" role="tab" aria-controls="nav-saved"
                                    aria-selected="false">
                                    Saved
                                </button>
                                <button class="nav-link" [ngClass]="{ active: activeTab === 'applied' }"
                                    (click)="onTabChange('applied')" id="nav-applied-tab" data-bs-toggle="tab"
                                    data-bs-target="#nav-applied" type="button" role="tab" aria-controls="nav-applied"
                                    aria-selected="false">
                                    Applied
                                </button>
                            </ng-container>
                        </div>
                    </nav>
                    }
                    <div class="col-lg-9 col-md-9 mt-20">
                        <div class="row g-3 align-items-start" *ngIf="all_jobs_tab">
                            <div *ngIf="jobData && jobData.length > 0; else noJobsFound">
                                <!-- <app-camp-aus-header></app-camp-aus-header> -->

                                @if(!this.jobsFiltersForm.value.is_camp_aus){
                                <ng-container *ngIf="is_camp_aus">
                                    <div class="camp-card1   px-20 c-p mb-20">
                                        <div>
                                            <img src="assets/images/camp_aus_image.png" alt="Camp Australia Logo" />
                                        </div>
                                        <div>
                                            <h1 class="user-title fs-23">Looking to work in OOSH?</h1>
                                            <p class="txt-regular ">
                                                Join Australia's leading provider of outside school hours care
                                            </p>
                                        </div>
                                        <div>
                                            <button type="button"
                                                (click)="$event.stopPropagation();applyFilters('global_search' , 'camp_aus')"
                                                class="cc_p_btn fs-13">Explore opportunities</button>
                                        </div>
                                    </div>
                                </ng-container>
                                }
                                @if(!this.jobsFiltersForm.value.is_camp_aus){
                                <h5 class="mb-0">Recommended jobs for you</h5>
                                }@else {
                                <h5 class="mb-0">Opportunities</h5>
                                }
                                @for (item of jobData; track item; let i = $index) {
                                <div class="card  p-3 c-p  mt-15"
                                    [ngClass]="item.is_boost_job? 'promoted-card' : 'job-card' "
                                    (click)="openJobDetails(item,'all')">
                                    <div class="row g-3 align-items-start">

                                        <!-- Logo -->
                                        <div class="col-12 col-sm-auto text-center">
                                            <img [src]="item?.school.profile_image ? item?.school?.profile_image
                                            : '../../../../assets/images/teacher-static-profile.png' " class="
                                            rounded-circle job-logo" alt="School Logo" />
                                        </div>

                                        <!-- Content -->
                                        <div class="col">

                                            <!-- Title + Actions -->
                                            <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
                                                <h5 class="mb-0 text-regular-bold fs-16">{{ item.job_title }}</h5>

                                                <div class="clr-grey-3 fs-14 d-flex align-items-center gap-3">
                                                    <span>Posted {{ item.time_ago }}</span>
                                                    <ng-container *ngIf="isAuthenticated">
                                                        <!-- <i class="bi bi-share" (click)="$event.stopPropagation()"></i> -->

                                                        @if(item.saved_status){
                                                        <i (click)="jobSaveUnsaveAPI(item.id,item.saved_status ? 'unsave' : 'save'); $event.stopPropagation()"
                                                            class="bi bi-bookmark-fill save_jobIcon c-p"></i>
                                                        }@else {
                                                        <i (click)="jobSaveUnsaveAPI(item.id,item.saved_status ? 'unsave' : 'save'); $event.stopPropagation()"
                                                            class="bi bi-bookmark save_jobIcon c-p"></i>
                                                        }
                                                    </ng-container>
                                                </div>
                                            </div>

                                            <!-- Meta -->
                                            <div class="text-muted txt-regular mt-5 mt-5">
                                                {{item.school.title}}
                                                <span class="mx-3">|</span>
                                                <i class="bi bi-geo-alt"></i> {{item.job_location}}
                                                @if(item.school_year_level.school_year_level_display){
                                                <span class="mx-3">|</span>
                                                <i
                                                    class="bi bi-building"></i>{{item.school_year_level.school_year_level_display}}
                                                }
                                            </div>
                                            @if(item.is_boost_job){
                                            <!-- Description -->
                                            <div class="job-desc mt-5 job-desc-clamp"
                                                [innerHTML]="(item.job_summary?.length > 350 ? (item.job_summary | slice:0:350) + '...' : item.job_summary)">
                                            </div>
                                            }

                                            <!-- Tags -->
                                            <div class="d-flex flex-wrap gap-2 mt-5">
                                                <span class="badge badge-soft-primary">{{ item.job_type }}</span>
                                                @if(item.is_boost_job){
                                                <span class="badge badge-soft-success">Promoted</span>
                                                }
                                                @if(item.expiring_soon){
                                                <span class="badge badge-soft-danger">Expiring soon</span>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <ng-template #noJobsFound>
                                <div class="card pt-30 pb-30 mt-15">
                                    <div class="text-center py-3">
                                        <img src="assets/PendingInvites_NoHistoryFound.png" alt="No Jobs"
                                            class="img-fluid mb-3" />
                                        <p class="text-muted user-title  mt-20 fs-16 small">No jobs at the moment</p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <div class="row g-3 align-items-start" *ngIf="saved_jobs_tab">
                            <div *ngIf="jobData && jobData.length > 0; else noJobsFound">
                                @for (item of jobData; track item; let i = $index) {
                                <div class="card  p-3 c-p mt-15"
                                    (click)="openSavedJobDetails(item,item?.job?.job_status)"
                                    [ngClass]="item?.job?.job_status == 'Expired' ? 'expired-card' : 'job-card' ">
                                    <div class="row g-3 align-items-start">

                                        <!-- Logo -->
                                        <div class="col-12 col-sm-auto text-center">
                                            <img [src]="item?.job?.school.profile_image ? item?.job?.school.profile_image
                                            : '../../../../assets/images/teacher-static-profile.png' " class="
                                            rounded-circle job-logo" alt="School Logo" />
                                        </div>

                                        <!-- Content -->
                                        <div class="col">
                                            <!-- Title + Actions -->
                                            <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
                                                <h5 class="mb-0 text-regular-bold fs-16">{{ item?.job?.job_title }}</h5>
                                                <div class="clr-grey-3 fs-14 d-flex align-items-center gap-3">
                                                    <span>Posted {{ item?.job?.time_ago }}</span>
                                                    <!-- <i (click)="jobSaveUnsaveAPI(item?.job?.id,'unsave'); $event.stopPropagation()"
                                                        class="bi bi-trash clr-cc-vilot save_jobIcon c-p"></i> -->
                                                </div>
                                            </div>

                                            <!-- Meta -->
                                            <div class="text-muted txt-regular mt-5 mt-5">
                                                {{item?.job?.school.title}}
                                                <span class="mx-3">|</span>
                                                <i class="bi bi-geo-alt"></i> {{item?.job?.state}}
                                                @if(item?.job?.school_level){
                                                <span class="mx-3">|</span>
                                                <i class="bi bi-building"></i>{{item?.job?.school_level}}
                                                }
                                            </div>
                                            @if(item.is_boost_job){
                                            <!-- Description -->
                                            <div class="job-desc  mt-5 job-desc-clamp"
                                                [innerHTML]="(item?.job?.job_summary?.length > 350 ? (item?.job?.job_summary | slice:0:350) + '...' : item?.job?.job_summary)">
                                            </div>
                                            }

                                            <!-- Tags -->
                                            <div class="d-flex flex-wrap gap-2 mt-5">
                                                <span class="badge badge-soft-primary">{{ item?.job?.job_type }}</span>
                                                @if(item?.job?.is_boost_job){
                                                <span class="badge badge-soft-success">Promoted</span>
                                                }
                                                @if(item?.job?.expiring_soon && item?.job?.job_status != 'Expired' ){
                                                <span class="badge badge-soft-danger">Expiring soon</span>
                                                }
                                                @if(item?.job?.job_status == 'Expired' ){
                                                <span class="badge badge-soft-danger">Expired</span>
                                                }
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <ng-template #noJobsFound>
                                <div class="card px-30 mt-20">
                                    <div class="text-center mt-20">
                                        <p>
                                            <img style="width: 150px;" src="assets/Requests_NoRequestsFound.png"
                                                alt="You have not saved any jobs yet. Save a job from All jobs tab to see them over here." />
                                        </p>
                                        <p class="text-muted user-title  mt-20 fs-16 small">You have not saved any jobs
                                            yet.
                                            Save a job from All jobs tab
                                            to see them over here.</p>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <div class="row g-3 align-items-start" *ngIf="applied_jobs_tab">
                            <div *ngIf="jobData && jobData.length > 0; else noJobsFound">
                                @for (item of jobData; track item; let i = $index) {
                                <div class="card  p-3 c-p  mt-15" *ngIf="item?.job?.job_status != 'Expired'"
                                    [ngClass]="item?.job?.job_status == 'Expired' ? 'expired-card' : 'job-card' "
                                    (click)="openAppliedJobDetails(item)">
                                    <div class="row g-3 align-items-start">

                                        <!-- Logo -->
                                        <div class="col-12 col-sm-auto text-center">
                                            <img [src]="item?.job?.school.profile_image ? item?.job?.school.profile_image
                                            : '../../../../assets/images/teacher-static-profile.png' " class="
                                            rounded-circle job-logo" alt="School Logo" />
                                        </div>

                                        <!-- Content -->
                                        <div class="col">
                                            <!-- Title + Actions -->
                                            <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
                                                <h5 class="mb-0 text-regular-bold fs-16">{{ item?.job?.job_title }}</h5>
                                                <div class="clr-grey-3 fs-14 d-flex align-items-center gap-1">
                                                    <span>Posted {{ item?.job?.time_ago }}</span> |
                                                    Applied {{item?.applied_at?.timeago}}
                                                    <!-- <i (click)="jobSaveUnsaveAPI(item?.job?.id,'unsave'); $event.stopPropagation()"
                                                        class="bi bi-trash clr-cc-vilot save_jobIcon c-p"></i> -->
                                                </div>
                                            </div>

                                            <!-- Meta -->
                                            <div class="text-muted txt-regular mt-5  mt-5">
                                                {{item?.job?.school.title}}
                                                <span class="mx-3">|</span>
                                                <i class="bi bi-geo-alt"></i> {{item?.job?.state}}
                                                @if(item?.job?.school_level){
                                                <span class="mx-3">|</span>
                                                <i class="bi bi-building"></i>{{item?.job?.school_level}}
                                                }
                                            </div>
                                            @if(item.is_boost_job){
                                            <!-- Description -->
                                            <div class="job-desc  mt-5 job-desc-clamp"
                                                [innerHTML]="(item?.job?.job_summary?.length > 350 ? (item?.job?.job_summary | slice:0:350) + '...' : item?.job?.job_summary)">
                                            </div>
                                            }
                                            <!-- Tags -->
                                            <div class="d-flex flex-wrap gap-2 mt-5">
                                                <span class="badge badge-soft-primary">{{ item?.job?.job_type }}</span>
                                                @if(item?.job?.is_boost_job){
                                                <span class="badge badge-soft-success">Promoted</span>
                                                }
                                                @if(item?.job?.job_status == 'Expired' ){
                                                <span class="badge badge-soft-danger">Expiried</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            <ng-template #noJobsFound>
                                <div class="card px-30 mt-20">
                                    <div class="text-center mt-20">
                                        <p>
                                            <img style="width: 130px;" src="assets/image 31.png"
                                                alt="You have not applied for any jobs yet. Apply for a job from All jobs tab to see them over here." />
                                        </p>
                                        <p class="text-muted user-title  mt-20 fs-16 small">You have not applied for any
                                            jobs yet. Apply for a job from All jobs tab to see them over here.</p>
                                    </div>
                                </div>
                            </ng-template>

                        </div>
                        <ng-container *ngIf="!loading && jobData && jobData.length > 0 && totalCount > 10">
                            <pagination class="mt-20" [ngModelOptions]="{standalone: true}" [totalItems]="totalCount"
                                class="pagination-sm mt-20" [boundaryLinks]="true" [rotate]="true" [maxSize]="5"
                                [(ngModel)]="page" (pageChanged)="pageChanged($event)">
                            </pagination>
                        </ng-container>
                    </div>
                    <div class="col-lg-3 col-md-3 mt-20">
                        <div class="text-end mb-4">
                            <a *ngIf="isAuthenticated" href="/teacher/settings"
                                class="btn-outline  px-4 py-2 fw-semibold">
                                Manage job alerts
                            </a>
                            <a href="https://booking-test.classcover.com.au/signup" *ngIf="!isAuthenticated"
                                class="cc-blue-btn pl-20 pt-10 pr-20 pb-10 fs-14 mt-10 fit-content ">
                                Sign up to manage job alerts
                            </a>
                        </div>
                        <div *ngIf="jobData.length > 0">
                            <!-- Schools actively hiring -->
                            <div class="card job-box px-16 mb-4 mt-20">
                                <h5 class="fw-semibold fs-18 mb-10">Schools actively hiring</h5>
                                <ng-container
                                    *ngIf="sideComponentData.actively_hire_school?.length; else noActiveSchools">
                                    <div (click)="openJobDetails(job,'all')"
                                        class="job-mini d-flex h_b_ul c-p gap-3 mb-10"
                                        *ngFor="let job of sideComponentData.actively_hire_school">
                                        <img [src]="job.school_profile_image ? job.school_profile_image : '../../../../assets/images/teacher-static-profile.png'"
                                            class="rounded-circle job-logo" alt="School Logo" />
                                        <div>
                                            <div class="mb-0 text-regular-bold   fs-16">{{ job.job_title }}</div>
                                            <div class="text-muted small">{{ job.school.title }}</div>
                                            <div class="text-muted small">
                                                <i class="bi bi-geo-alt"></i> {{ job.suburb }} {{ job.state }}
                                            </div>
                                        </div>

                                    </div>
                                    <!-- <a href="#" class="text-primary fw-semibold text-decoration-none">
                                    View all <i class="bi bi-arrow-right"></i>
                                </a> -->
                                </ng-container>
                                <ng-template #noActiveSchools>
                                    <div class="d-flex align-items-center">
                                        <img alt="img" class="img-fluid" style="max-width: 80px;"
                                            src="assets/Search.png" />
                                        <div class="text-muted user-title fs-14 small ml-10">No schools are actively
                                            hiring
                                            right
                                            now.</div>
                                    </div>
                                </ng-template>

                            </div>

                            <!-- Be an early applicant -->
                            <div class="card job-box px-16 mb-4 mt-15">
                                <h5 class="fw-semibold fs-18 mb-10">Be an early applicant</h5>
                                <ng-container *ngIf="sideComponentData.early_applicant?.length; else noEarlyApplicant">
                                    <div (click)="openJobDetails(job,'all')"
                                        class="job-mini d-flex h_b_ul c-p gap-3 mb-10"
                                        *ngFor="let job of sideComponentData.early_applicant">
                                        <img [src]="job.school_profile_image ? job.school_profile_image : '../../../../assets/images/teacher-static-profile.png'"
                                            class="rounded-circle job-logo" alt="School Logo" />
                                        <div>
                                            <div class="mb-0 text-regular-bold fs-16">{{ job.job_title }}</div>
                                            <div class="text-muted small">{{ job.school.title }}</div>
                                            <div class="text-muted small">
                                                <i class="bi bi-geo-alt"></i> {{ job.suburb }} {{ job.state }}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <a href="#" class="text-primary fw-semibold text-decoration-none">
                                    Apply now <i class="bi bi-arrow-right"></i>
                                </a> -->
                                </ng-container>
                                <ng-template #noEarlyApplicant>
                                    <div class="d-flex align-items-center">
                                        <img alt="img" class="img-fluid" style="max-width: 80px;"
                                            src="assets/PreBooking_NoMatchesFound_Post copy.png" />
                                        <div class="text-muted user-title fs-14 small">No jobs available to be an
                                            early applicant.</div>
                                    </div>
                                </ng-template>
                            </div>

                            <!-- Expiring soon -->
                            <div class="card job-box px-16 mt-15" *ngIf="isAuthenticated">
                                <h5 class="fw-semibold fs-18 mb-10">A job you saved is expiring soon</h5>
                                <ng-container *ngIf="sideComponentData.saved_expire?.length; else noSavedExpire">
                                    <div *ngFor="let job of sideComponentData.saved_expire">
                                        <div class="job-mini d-flex gap-3 mb-10">
                                            <img [src]="job.school_profile_image ? job.school_profile_image : '../../../../assets/images/teacher-static-profile.png'"
                                                class="rounded-circle job-logo" alt="School Logo" />
                                            <div>
                                                <div class="mb-0 text-regular-bold fs-16">{{ job.job.job_title }}</div>
                                                <div class="text-muted small">{{ job.job.school.title }}</div>
                                                <div class="text-muted small">
                                                    <i class="bi bi-geo-alt"></i> {{ job.job.suburb }} {{ job.job.state
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <a (click)="redirectToSaveTab(job.job.id,'saved')" role="button "
                                            class="text-primary user-title text-decoration-none c-p">
                                            Apply now <i class="bi bi-arrow-right"></i>
                                        </a>
                                    </div>
                                </ng-container>
                                <ng-template #noSavedExpire>
                                    <div class="d-flex align-items-center">
                                        <img alt="img" class="img-fluid" style="max-width: 80px;"
                                            src="assets/PreBooking_NoMatchesFound_Post copy.png" />
                                        <div class="text-muted user-title fs-14 small">A No jobs are expiring from your
                                            saved jobs list.</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>